var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { isObject, isTruthy } from '@cvent/carina-utils';
var DEFAULT_PADDING = 8;
var LARGE_PADDING = 12;
var VALID_START_PADDINGS = ['start', 'paddingStart', 'left', 'paddingLeft'];
var VALID_END_PADDINGS = ['end', 'paddingEnd', 'right', 'paddingRight'];
var isNumber = function (padding) {
    return typeof padding === 'number';
};
var hasValidStartPaddingValue = function (padding) {
    return Object.keys(padding).some(function (p) { return VALID_START_PADDINGS.includes(p); });
};
var hasValidEndPaddingValue = function (padding) {
    return Object.keys(padding).some(function (p) { return VALID_END_PADDINGS.includes(p); });
};
export default function ColStyles(_a) {
    var zIndex = _a.zIndex, breakpoints = _a.breakpoints, componentDefaults = _a.componentDefaults, componentS = _a.s, componentM = _a.m, componentL = _a.l, componentXL = _a.xl, isRtl = _a.isRtl;
    var _b = defineStartAndEnd(isRtl), start = _b.start, end = _b.end;
    var colBase = {
        zIndex: zIndex,
        direction: (isRtl === true && 'rtl') || (isRtl === false && 'ltr') || 'inherit',
        boxSizing: 'border-box',
        position: 'relative',
        display: 'block',
        flexShrink: 0,
        flexGrow: 0,
        flexBasis: 'auto',
        flexWrap: 'nowrap',
        flexDirection: 'row',
        justifyContent: 'start',
        alignItems: 'stretch',
        minHeight: 'inherit'
    };
    var resolveDefaultPaddingWithOverrides = function (colStyles, defaultPadding) {
        return expandPadding(__assign(__assign({}, colStyles), { padding: __assign(__assign(__assign({}, (!isTruthy(colStyles.padding) && {
                start: defaultPadding,
                end: defaultPadding
            })), (isNumber(colStyles.padding) && {
                start: colStyles.padding,
                end: colStyles.padding
            })), (isObject(colStyles.padding) && __assign(__assign(__assign({}, colStyles.padding), (!hasValidStartPaddingValue(colStyles.padding) && { start: defaultPadding })), (!hasValidEndPaddingValue(colStyles.padding) && { end: defaultPadding })))) }));
    };
    var responsiveCols = function () {
        var _a;
        var defaults = resolveDefaultPaddingWithOverrides(componentDefaults, DEFAULT_PADDING);
        var userS = __assign(__assign({}, expandPadding(componentDefaults)), expandPadding(componentS));
        var userM = __assign(__assign({}, userS), expandPadding(componentM));
        var userL = __assign(__assign({}, userM), expandPadding(componentL));
        var userXl = __assign(__assign({}, userL), expandPadding(componentXL));
        var resolvedL = resolveDefaultPaddingWithOverrides(userL, LARGE_PADDING); // Spread large defaults only if a user override isn't present through a previous user setting
        var resolvedXl = __assign(__assign({}, resolvedL), userXl); // Large defaults inherited from rL
        function buildStyleAtBreakpoint(colStyle) {
            var _a, _b, _c;
            var resolvedColStyles = __assign(__assign(__assign({}, colStyle.flex), widthProperties(colStyle.width, colStyle.minWidth)), (_a = {}, _a["margin" + start] = convertWidthValue(colStyle.offset), _a["margin" + end] = convertWidthValue(colStyle.offsetEnd), _a));
            var padding = colStyle.padding;
            if (!isTruthy(padding)) {
                return resolvedColStyles;
            }
            return __assign(__assign(__assign(__assign(__assign({}, resolvedColStyles), (isTruthy(padding.paddingTop) && {
                paddingTop: padding.paddingTop + "px"
            })), (isTruthy(padding.paddingBottom) && {
                paddingBottom: padding.paddingBottom + "px"
            })), (isTruthy(padding.paddingStart) && (_b = {},
                _b["padding" + start] = padding.paddingStart + "px",
                _b))), (isTruthy(padding.paddingEnd) && (_c = {},
                _c["padding" + end] = padding.paddingEnd + "px",
                _c)));
        }
        return __assign(__assign({}, buildStyleAtBreakpoint(defaults)), (_a = {}, _a["@media (min-width: " + breakpoints.s + ")"] = buildStyleAtBreakpoint(userS), _a["@media (min-width: " + breakpoints.m + ")"] = buildStyleAtBreakpoint(userM), _a["@media (min-width: " + breakpoints.l + ")"] = buildStyleAtBreakpoint(resolvedL), _a["@media (min-width: " + breakpoints.xl + ")"] = buildStyleAtBreakpoint(resolvedXl), _a));
    };
    return __assign(__assign({}, colBase), responsiveCols());
}
function expandPadding(colStyles) {
    if (!isTruthy(colStyles)) {
        return; // we want a falsey value not an empty object here
    }
    var padding = colStyles.padding;
    if (!isTruthy(padding)) {
        return colStyles;
    }
    if (isNumber(padding)) {
        return __assign(__assign({}, colStyles), { padding: {
                paddingEnd: padding,
                paddingStart: padding
            } });
    }
    return __assign(__assign({}, colStyles), { padding: __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, (isTruthy(padding.paddingTop) && { paddingTop: padding.paddingTop })), (isTruthy(padding.top) && { paddingTop: padding.top })), (isTruthy(padding.paddingBottom) && {
            paddingBottom: padding.paddingBottom
        })), (isTruthy(padding.bottom) && { paddingBottom: padding.bottom })), (isTruthy(padding.paddingRight) && {
            paddingEnd: padding.paddingRight
        })), (isTruthy(padding.right) && { paddingEnd: padding.right })), (isTruthy(padding.paddingEnd) && { paddingEnd: padding.paddingEnd })), (isTruthy(padding.end) && { paddingEnd: padding.end })), (isTruthy(padding.paddingStart) && {
            paddingStart: padding.paddingStart
        })), (isTruthy(padding.start) && { paddingStart: padding.start })), (isTruthy(padding.paddingLeft) && {
            paddingStart: padding.paddingLeft
        })), (isTruthy(padding.left) && { paddingStart: padding.left })) });
}
function convertWidthValue(numWidth) {
    /*
    minWidth="content"
    'max-content' is not supported in IE, and therefore cannot be used
    even though it works great in browsers real people use
    if (numWidth === 'content') {
      return 'max-content';
    }
    */
    if (typeof numWidth === 'number') {
        if (numWidth > 0 && numWidth <= 1) {
            return numWidth * 100 + "%";
        }
        return numWidth + "px";
    }
    return 0;
}
function widthProperties(numWidth, numMinWidth) {
    var minWidth = numMinWidth !== undefined && {
        minWidth: convertWidthValue(numMinWidth)
    };
    if (typeof numWidth === 'number') {
        if (numWidth > 0 && numWidth <= 1) {
            return __assign(__assign({}, minWidth), { width: numWidth * 100 + "%", flexGrow: 0 });
        }
        return __assign(__assign({}, minWidth), { width: numWidth + "px", flexGrow: 0 });
    }
    if (numWidth === 'content') {
        return __assign(__assign({}, minWidth), { width: 'auto', flexGrow: 0, flexShrink: 0 });
    }
    // defaults to 'fill'
    return __assign(__assign({}, minWidth), { width: 0, flexGrow: 1 });
}
function defineStartAndEnd(isRtl) {
    return isRtl
        ? { start: 'Right', end: 'Left' }
        : { start: 'Left', end: 'Right' };
}
